import { useContext } from 'react';
import { RRule } from 'rrule';
import { ActionSheet } from '@shared/components/ActionSheet';
import { View } from '@shared/components/View';
import { NativeDropdownButton } from '@shared/components/dropdown';
import { MBIconV2 } from '@shared/components/image';
import { MBTextInput } from '@shared/components/textInput';
import { MBTextBody1Bold } from '@shared/components/typography';
import { Batch } from '@shared/scenes/cards/entityBulkActions/BatchCreateContext/BatchContext';
import { ColorThemeContext, Colors, grid } from '@shared/styles';
import { useBoolean } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import { MonthOptions } from './MonthOptions';
import { WeekOptions } from './WeekOptions';
import { YearOptions } from './YearOptions';
import { useCustomBatch } from './hooks/useCustomBatch';

export function CustomBatchMobile({
  rruleOptions,
  setRruleOptions,
  setUserIsEditing,
}: Pick<Batch, 'rruleOptions' | 'setRruleOptions' | 'setUserIsEditing'>) {
  const colors = useContext(ColorThemeContext);
  const [showFreqMenu, openFreqMenu, closeFreqMenu] = useBoolean();
  const anchorName = '--custom-batch-freq-menu';

  const { frequencyLabel, interval, freqOptions, handleIntervalChange } = useCustomBatch({
    rruleOptions,
    setRruleOptions,
    setUserIsEditing,
  });

  return (
    <>
      <MBTextBody1Bold>{i18n('workflowTemplate.component.dateAndRepeat.every')}</MBTextBody1Bold>
      <View
        row
        centerVertically
        style={{
          width: '100%',
          justifyContent: 'flex-start',
        }}
        marginVertical={1.5}
      >
        <View style={{ flexShrink: 0, flexGrow: 0 }} marginRight={2}>
          <MBIconV2 name="repeat" size={35} color={colors.accent} />
        </View>
        <MBTextInput
          value={String(interval ?? '')}
          onChangeText={handleIntervalChange}
          noPadding
          style={{
            width: grid(6.5),
            height: grid(5.5),
            paddingHorizontal: grid(2),
            backgroundColor: Colors.v2.backgroundGrayLight,
            borderWidth: 0,
          }}
        />
        <View style={{ anchorName }}>
          <NativeDropdownButton onPress={openFreqMenu} disabled={!showFreqMenu}>
            {frequencyLabel}
          </NativeDropdownButton>
        </View>
        {showFreqMenu && (
          <ActionSheet anchorName={anchorName} onClose={closeFreqMenu} options={freqOptions} />
        )}
      </View>
      {rruleOptions?.freq === RRule.WEEKLY && (
        <WeekOptions rruleOptions={rruleOptions} setRruleOptions={setRruleOptions} />
      )}
      {rruleOptions?.freq === RRule.MONTHLY && (
        <MonthOptions rruleOptions={rruleOptions} setRruleOptions={setRruleOptions} />
      )}
      {rruleOptions?.freq === RRule.YEARLY && (
        <YearOptions rruleOptions={rruleOptions} setRruleOptions={setRruleOptions} />
      )}
    </>
  );
}
